import type { ReactNode } from "react";

import ResumenSection from "./sections/ResumenSection";
import ExpedientesSection from "./sections/ExpedientesSection";
import RepositorioSection from "./sections/RepositorioSection";
import PlantillasSection from "./sections/PlantillasSection";
import VencimientosSection from "./sections/VencimientosSection";
import { DOCUMENTACION_APP_ID, DOCUMENTACION_BASE, SECTIONS, documentacionApp, documentacionDefaultRoute, documentacionSubjectRoute } from "./nav";

// ---------------------------------------------------------------------------
// App «Documentación» (CC-CONSOLE #1632): expediente documental de embarques.
// Única fuente de verdad de su navegación. Alimenta:
//   - el submenú del layout (DocumentacionLayout)
//   - las rutas anidadas (router/config.tsx vía routes.tsx)
//   - el mosaico del AppsSidebar (appsConfig.tsx, vía ./nav)
// Los ids de sección son los mismos del preset (wayak-config.json →
// freight-forwarding/documentacion/menu) y del catálogo de derechos
// (menu:documentacion.<id>); menu-preset.test.ts los lee de este MENU literal.
// ---------------------------------------------------------------------------

export interface DocumentacionNavItem {
  id: string; // segmento de ruta bajo /documentacion
  labelKey: string; // clave i18n en el namespace `documentacion` (menu.<id>)
  icon: string; // remixicon
  element: ReactNode;
}

const section = (id: string) => SECTIONS.find((s) => s.id === id) ?? { id, labelKey: `menu.${id}`, icon: "ri-file-line" };

export const MENU: DocumentacionNavItem[] = [
  { ...section("resumen"), id: "resumen", element: <ResumenSection /> },
  { ...section("expedientes"), id: "expedientes", element: <ExpedientesSection /> },
  { ...section("repositorio"), id: "repositorio", element: <RepositorioSection /> },
  { ...section("plantillas"), id: "plantillas", element: <PlantillasSection /> },
  { ...section("vencimientos"), id: "vencimientos", element: <VencimientosSection /> },
];

export { DOCUMENTACION_APP_ID, DOCUMENTACION_BASE, documentacionApp, documentacionDefaultRoute, documentacionSubjectRoute };
